import { Component, OnInit, ViewChild  } from '@angular/core';
import { DashboardService } from '../service/dashboard.service';
import { Router } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatDatepickerInputEvent, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { FormControl } from '@angular/forms';


import { MatDateFormats, MAT_NATIVE_DATE_FORMATS } from '@angular/material';


export const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions,
  }
};
@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
  ]
})
export class CustomersComponent implements OnInit {

  userdata;
  customers:any = [];
  searchdata;


  minDate: Date;
  maxDate: Date;

  startDate :any
  endDate  : any


  length: number;
  pageSize: number= 10;
  pageSizeOptions = [ 10, 20,50,100];


  dataSource = new MatTableDataSource();
  displayedColumns = ['no' ,'client_id', 'first_name','phone', 'email','date_createdd']


  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor( private router: Router, private service: DashboardService,
    private readonly adapter: DateAdapter<Date>) {
      const currentYear = new Date().getFullYear();
      this.minDate = new Date(currentYear - 2, 0, 1);
      // this.maxDate = new Date(currentYear + 1, 11, 31);
      this.maxDate = new Date(currentYear + 1, 0, 0);
     }

     date = new FormControl(new Date(new Date().setDate(new Date().getDate() - 90)));

     serializedDate = new FormControl((new Date()).toISOString().substring(0,10));

  ngOnInit() {

    this.userdata=JSON.parse(localStorage.getItem('userdata'))

    var today = new Date(); //get todays date
    this.endDate= today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date

    today.setDate(today.getDate() - 90) // subtract 7 days from todays date
    this.startDate = today.toISOString().substring(0,10)


     this.service.getCustomers({email:this.userdata.email, role :this.userdata.role ,module: "client" ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
       this.customers = data['responseData'];
       this.searchdata = this.customers;
       this.dataSource.data =  this.customers;
       this.dataSource.paginator = this.paginator;
       //console.log(data)
  });

}


find(){
  //email:this.ud.email,minDate:this.topperformstartdate,maxDate:this.topperformenddate,duration:days.toString(), role:this.ud.role}
  this.service.getAgents({email:this.userdata.email, role :this.userdata.role ,module: "client" ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{

    this.customers = data['responseData'];
       this.searchdata = this.customers;
       this.dataSource.data =  this.customers;
       this.dataSource.paginator = this.paginator;
});




}

applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
}




updateDate1(dateObject) {
  // convert object to string then trim it to yyyy-mm-dd
  const stringified = JSON.stringify(dateObject.value);
  this.startDate = stringified.substring(1, 11);
  // this.applicant.contact[0].dob = dob;

  console.log(this.startDate )
}


updateDate2(dateObject) {
  // convert object to string then trim it to yyyy-mm-dd
  const stringified = JSON.stringify(dateObject.value);
  this.endDate = stringified.substring(1, 11);
  // this.applicant.contact[0].dob = dob;

  console.log("end date " + this.endDate )
}



search (query: string){
  this.searchdata = (query) ?this.customers.filter( data => data.client_id.toLowerCase().includes(query.toLowerCase()) || data.last_name.toLowerCase().includes(query.toLowerCase()) || data.date_updated.toLowerCase().includes(query.toLowerCase()) || data.created_by.toLowerCase().includes(query.toLowerCase()) || data.email.toUpperCase().includes(query.toUpperCase())) : this.customers;
}

Cusinfo(){
  this.router.navigate(['/customers'])
}

Transactions(){
  this.router.navigate(['/transactions'])
}


newclient(){
  this.router.navigate(['/newcustomer']);
    }

  Policylists(){
    this.router.navigate(['/policylistings'])
  }

}
